import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/UI/Tooltip';

export default function QuestionMarkTooltip({ toolTip }: { toolTip: React.ReactNode }) {
  return (
    <Tooltip>
      <TooltipTrigger className='text-neutralColor-light hover:text-neutralColor-normal transition-colors inline'>
        <QuestionMarkCircleIcon className='w-5 h-5' />
      </TooltipTrigger>
      <TooltipContent className='text-xs'>{toolTip}</TooltipContent>
    </Tooltip>
  );
}
